<template>
  <transition name="fade">
    <div class="Terms" v-if="visible">
      <img
        class="Terms-logo"
        ref="logo"
        src="@/assets/img/logo.svg"
        alt="Carta Blanca"
      />
      <div class="Terms-close" @click="$emit('close')" />
      <TermsText />
    </div>
  </transition>
</template>

<script>
import TermsText from "@/components/TermsText";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  components: {
    TermsText,
  },
};
</script>

<style lang="stylus" scoped>
@import 'Terms.styl';
</style>
